import { defineStore } from 'pinia';
import { actions, state } from '@/stores/methods';


export const useVonageStore = defineStore('vonage', {
  state: state,
  actions: actions,
  getters: {
    getByPhoneNumber: (state) => {
      return (phoneNumber) => state.collection.find(v => v.attributes['phone-number'] === phoneNumber);
    },
  },
});
